import {useAppSelector} from "../storage/hooks";
import {selectApps} from "../storage/slicers/appSlice";
import { Row } from 'react-bootstrap';
import Card from "../components/Card";
import {APP} from "../storage/constants/properties";

function AllApps() {
    const apps = useAppSelector(selectApps);

    return(
        <Row>
            {apps.map((app) => (
                <Card id={app.id} type={APP}/>
            ))}
        </Row>
    );
}

export default AllApps;